export enum Permission {
  BHB_READ = "BH.BOOKING.READ",
  BHB_WRITE = "BH.BOOKING.WRITE",
  PROS_USER_READ = "PROS.USER.READ",
  PROS_USER_WRITE = "PROS.USER.WRITE",
  ProsBpmWebAllowed = "PER-PROS-BPM-WEB-ALLOWED",
  BpmConsultAllowed = "PER-BPM-CONSULT-ALLOWED",
  PerPltUserRead = "PER-PLT-USER-READ",
  PerPltUserWrite = "PER-PLT-USER-WRITE",
  PerPltLicenceRead = "PER-PLT-LICENCE-READ",
  PerPltLicenceWrite = "PER-PLT-LICENCE-WRITE",
  PerPltNetworkRead = "PER-PLT-NETWORK-READ",
  PerPltNetworkWrite = "PER-PLT-NETWORK-WRITE",
  ProsBhbAssignLicenceAllowed = "PER-PROS-BHB-ASSIGN-LICENCE-ALLOWED",
  ProsOnlineSettingsSubscriptionManagementAllowed = "PER-PROS-SETTINGS-SUB-MGMT-ALLOWED",
  ProsEditNetworkAllowed = "PER-PROS-SETTINGS-EDIT-NETWORK-ALLOWED",
  ProsBhbDisplayClinicSearchAllowed = "PER-PROS-BHB-CLINIC-SEARCH-ALLOWED"
}
